import { Button } from '@cropler/ui-kit';

import styles from './styles.module.scss';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

const SidebarItemCompare = ({ isActive, onClickButton, isButtonLarge }) => {
  return (
    <Button
      className={`${styles.sidebarItemCompare} ${isActive && styles.sidebarItemCompareActive}`}
      type={'text'}
      icon={isActive ? <CroplerIcon name="compareFull" /> : <CroplerIcon name="compare" />}
      size={isButtonLarge ? 'large' : ''}
      onClick={onClickButton}
    />
  );
};

export default SidebarItemCompare;
